// Industry category codes
const industryCodes: Record<string, string> = {
  'Artificial Intelligence': '01',
  'Electric Vehicles': '02',
  Biotechnology: '03',
  Semiconductors: '04',
  'Renewable Energy': '05',
  Robotics: '06',
  Fintech: '07',
  Aerospace: '08',
  Technology: '09',
  'Cloud Computing': '10',
  'Autonomous Driving': '11',
  'Energy Storage': '12',
  Pharmaceuticals: '13',
}

function abbreviate(subIndustry: string): string {
  const words = subIndustry
    .replace(/[^a-zA-Z\s]/g, '')
    .split(/\s+/)
    .filter(Boolean)
  if (words.length >= 3) {
    return (words[0][0] + words[1][0] + words[2][0]).toUpperCase()
  }
  if (words.length === 2) {
    return (words[0][0] + words[0][1] + words[1][0]).toUpperCase()
  }
  return words[0].slice(0, 3).toUpperCase()
}

export function generateIndustryCode(
  industry: string,
  subIndustry: string,
  founded: number,
  id: string,
): string {
  const prefix = industryCodes[industry] || '99'
  const abbr = abbreviate(subIndustry)
  const endYear = founded + 5 + (parseInt(id, 10) % 20)
  return `${prefix}_${abbr}_${founded}-${endYear}`
}
